import { combineReducers } from 'redux';
import types from './types';
import UserModel from '../../../model/user.model';
import { IWarrantyError } from '../accountview/reducers';

const INITIAL_IS_PENDING = false;
const INITIAL_ERROR: IWarrantyError = {
  hasFailed: false,
  message: ''
};

const isPending = (
  state: boolean = INITIAL_IS_PENDING,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_USER_IS_PENDING:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const error = (
  state: IWarrantyError = INITIAL_ERROR,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_USER_ERROR:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const getUserAccountsIsPending = (
  state: boolean = false,
  { type, payload }: any
) => {
  switch (type) {
    case types.USER_ACCOUNTS_IS_PENDING:
      return payload;
    default:
      return state;
  }
};

const userData = (
  state: any = false,
  { type, payload }: { type: string; payload: UserModel }
) => {
  switch (type) {
    case types.USER_DATA:
      return payload;
    default:
      return state;
  }
};

const accounts = (state: any = [], { type, payload }: any) => {
  switch (type) {
    case types.USER_ACCOUNTS:
      return payload;
    default:
      return state;
  }
};

const accountsPagination = (
  state: any = { pageNumber: 0, total: 0, size: 20 },
  { type, payload }: any
) => {
  switch (type) {
    case types.USER_ACCOUNTS_PAGINATION:
      return payload;
    default:
      return state;
  }
};

const userDataError = (state: any = false, { type, payload }: any) => {
  switch (type) {
    case types.USER_DATA_ERROR:
      return payload;
    default:
      return state;
  }
};

const emailUpdated = (state: any = false, { type, payload }: any) => {
  switch (type) {
    case types.EMAIL_UPDATED:
      return payload;
    default:
      return state;
  }
};

const userReducer = combineReducers({
  isPending,
  error,
  getUserAccountsIsPending,
  userData,
  userDataError,
  accounts,
  accountsPagination,
  emailUpdated
});

export default userReducer;
